import { useEffect, useState } from "react";
import { X, Send, RefreshCw } from "lucide-react";
import { adminHttp, formatApiError } from "../../lib/adminApi";
import { toast } from "sonner";

export default function EmailLogModal({ logId, onClose, onResend }) {
  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await adminHttp.get(`/admin/emails/logs/${logId}`);
        setLog(data);
      } catch (e) { toast.error(formatApiError(e)); onClose(); }
      finally { setLoading(false); }
    })();
  }, [logId, onClose]);

  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur flex items-center justify-center p-4" onClick={onClose} data-testid="email-log-modal">
      <div className="bg-white border border-accent/60 max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="px-6 py-4 border-b border-[#DDE2D5] flex items-center justify-between">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-accent">Preview email</p>
            <p className="font-display font-black text-lg mt-1 truncate max-w-xl">{log?.subject || "—"}</p>
          </div>
          <button onClick={onClose} className="p-2 text-[#374151] hover:text-accent">
            <X className="w-5 h-5" />
          </button>
        </div>
        {loading || !log ? (
          <div className="p-10 text-center text-[#6B7280] font-mono text-xs">Cargando…</div>
        ) : (
          <div className="flex-1 overflow-auto grid grid-cols-1 md:grid-cols-[1fr_1.5fr] gap-0">
            <div className="p-6 border-r border-[#DDE2D5] space-y-3 overflow-auto">
              <Row label="Plantilla">{log.template_key}</Row>
              <Row label="Para">{(log.to || []).join(", ")}</Row>
              <Row label="Status">{log.status}</Row>
              <Row label="Resend ID">{log.resend_id || "—"}</Row>
              <Row label="Creado">{log.created_at}</Row>
              <Row label="Enviado">{log.sent_at || "—"}</Row>
              <Row label="Intentos">{log.attempts}</Row>
              <Row label="Lead">{log.lead_id || "—"}</Row>
              {log.error && <Row label="Error" danger>{log.error}</Row>}
              <div className="pt-4 flex gap-2">
                <button onClick={onResend} className="btn-accent py-2 px-4 text-xs flex-1 justify-center" data-testid="modal-resend">
                  <RefreshCw className="w-3 h-3 mr-1" /> Reenviar
                </button>
              </div>
            </div>
            <div className="bg-[#060606] p-3 overflow-auto">
              <iframe
                srcDoc={log.html || "<p style='color:white;font-family:Arial;'>Sin HTML disponible</p>"}
                title="email-preview"
                className="w-full h-[70vh] bg-white"
                data-testid="email-preview-iframe"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Row({ label, children, danger }) {
  return (
    <div>
      <p className="font-mono text-[10px] uppercase tracking-widest text-[#6B7280]">{label}</p>
      <p className={`text-sm mt-0.5 break-all ${danger ? "text-red-400" : "text-[#374151]"}`}>{children}</p>
    </div>
  );
}
